import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { IntercultureListPage } from '@interculture';

const searchSchema = z.object({
  type: z.string().optional(),
  selectedForm: z.number().optional(),
  editMode: z.boolean().optional(),
});

export const Route = createFileRoute('/_app/interculture')({
  validateSearch: (search) => searchSchema.parse(search),

  component: IntercultureListPage,
});
